import { Icon } from '@blueprintjs/core'
import React, { useEffect, useState } from 'react'
import { useMediaQuery } from 'react-responsive'
import {
    Button, FormInput, CheckboxInput,
    FormMultiSelect, Row, Col, Switch,
    FormSuggestWithCreate, CollapsableCard,
    Tooltip, Position
} from '../../../Elements'
import { useJobSearchCriteria, DEFAULT_JOB_SEARCH_CRITERIA } from '../../../Hooks/jobSearchCriteria'
import moment from 'moment'
import { envShowCentralTexas } from '../../../utils/helpers';



export default ({ isLoadingOrRefreshing, refetch, supervisors = [], homeowners = [], jobStatuses = [], customers = [], pebbleColors = [], jobCategories = [], cities = [], jobTypes = [], forMap = false }) => {
    const { contextSearchCriteria, setContextSearchCriteria, resetContextSearchCriteria, getMappedInternalSearchCriteria } = useJobSearchCriteria()

    const [internalSearchState, setInternalSearchState] = useState(contextSearchCriteria)

    const combinedSupervisorOptions = supervisors.concat(homeowners.map(h => ({ ...h, id: `${h.id}-h` })))

    const refreshResults = () => {
        setContextSearchCriteria(internalSearchState)
        // if (!forMap) {
        //     refetch({ searchCriteria: getMappedInternalSearchCriteria(forMap, internalSearchState) })
        // }
        // else 
        if (isMapSearchCriteriaEntered(getMappedInternalSearchCriteria(forMap, internalSearchState))) {
            refetch({ variables: { searchCriteria: getMappedInternalSearchCriteria(forMap, internalSearchState) } })
        }
    }

    const clearFiltersAndRefreshResults = () => {
        resetContextSearchCriteria()
        setInternalSearchState(DEFAULT_JOB_SEARCH_CRITERIA)
        let mapped = getMappedInternalSearchCriteria(forMap, internalSearchState)
        if (!forMap) {
            refetch({ searchCriteria: mapped })
        }
        else if (isMapSearchCriteriaEntered(mapped)) {
            refetch({ variables: { searchCriteria: mapped } })
        }
    }

    const customUpdateSearchCriteria = (criteriaName, newValue) => {
        const newSearchCriteria = {
            ...internalSearchState
        }

        if (criteriaName === 'is_request_form') {
            newValue = internalSearchState.is_request_form === null
                ? true
                : internalSearchState.is_request_form
                    ? false
                    : null
        }
        if (criteriaName === 'number') {
            newValue = newValue != null ? parseInt(newValue) : newValue
        }
        newSearchCriteria[criteriaName] = newValue
        setInternalSearchState(newSearchCriteria)
        //setContextSearchCriteria(newSearchCriteria)
    }

    const isMapSearchCriteriaEntered = (criteria) => {
        return criteria.category.length > 0 ||
            criteria.color.length > 0 ||
            criteria.company.length > 0 ||
            criteria.is_central_texas ||
            criteria.is_request_form !== null ||
            criteria.status.length > 0 ||
            criteria.supervisor.length > 0 ||
            criteria.address ||
            criteria.city ||
            criteria.job_type.length > 0 ||
            criteria.entered_start_date ||
            criteria.entered_end_date ||
            criteria.name ||
            criteria.number ||
            criteria.scheduled_app_date
    }

    const isEndDateSearchWarning = () => {
        return internalSearchState.entered_end_date && !internalSearchState.entered_start_date
    }

    const isDateRangeSearchWarning = () => {
        return moment(internalSearchState.entered_end_date).diff(internalSearchState.entered_start_date, 'month') >= 3
    }

    const dateRangeToolTip = (isEndDate) => {
        return <Tooltip
            content={<div>
                <Icon icon='warning-sign' />
                <span style={{ fontWeight: 'bold', paddingLeft: 2 }}>Results will be limited to 4000 records</span>
            </div>}
            position={Position.TOP}
            disabled={(isEndDate ? !isEndDateSearchWarning() : !isDateRangeSearchWarning())}
            intent='warning'
            className='job-map-search-warning'

        >
            {(isEndDate ? !isEndDateSearchWarning() : !isDateRangeSearchWarning()) ? '' : <Icon icon='warning-sign' />}
        </Tooltip>
    }

    useEffect(() => {
        const onKeyUp = (e) => {
            if (e.key === 'Enter') {
                let multiselectHasFocus = document.activeElement.className.includes('multi-select')
                if (multiselectHasFocus === false) {
                    refreshResults()
                }
            }
        }

        window.addEventListener("keyup", onKeyUp)

        return () => window.removeEventListener("keyup", onKeyUp)
    })

    const isNarrow = useMediaQuery({ query: '(max-width: 1030px)' })
    return <CollapsableCard title='Job Filters'>
        <Row middle='lg'>
            <Col lg={11}>
                <Row>
                    <Col xs={6} sm={4} md={2}>
                        <FormMultiSelect
                            id='criteria-company'
                            label='Companies'
                            label_property={'company_name'}
                            value={internalSearchState.company}
                            disabled={isLoadingOrRefreshing}
                            items={customers.filter(c => c.is_active)}
                            onChange={(v) => customUpdateSearchCriteria('company', v)}
                        />
                    </Col>
                    <Col xs={6} sm={4} md={2}>
                        <FormMultiSelect
                            id='criteria-category'
                            label='Supervisor'
                            items={combinedSupervisorOptions}
                            value={internalSearchState.supervisor}
                            disabled={isLoadingOrRefreshing}
                            onChange={(v) => customUpdateSearchCriteria('supervisor', v)}
                        />
                    </Col>
                    <Col xs={6} sm={4} md={2}>
                        <FormMultiSelect
                            id='criteria-category'
                            label='Job Categories'
                            value={internalSearchState.category}
                            disabled={isLoadingOrRefreshing}
                            items={jobCategories}
                            onChange={(v) => customUpdateSearchCriteria('category', v)}
                        />
                    </Col>
                    <Col xs={6} sm={4} md={2}>
                        <FormInput
                            label='Name'
                            id='criteria-name'
                            placeholder='Name'
                            value={internalSearchState.name}
                            disabled={isLoadingOrRefreshing}
                            onChange={(evt) => customUpdateSearchCriteria('name', evt.target.value)}
                        />
                    </Col>
                    <Col xs={6} sm={4} md={2}>
                        <FormInput
                            label='Number'
                            placeholder='Number'
                            id='criteria-number'
                            type='number'
                            value={internalSearchState.number}
                            disabled={isLoadingOrRefreshing}
                            onChange={(evt) => customUpdateSearchCriteria('number', evt.target.value)}
                        />
                    </Col>
                    <Col xs={6} sm={4} md={2}>
                        {envShowCentralTexas &&
                            <Switch
                                large
                                innerLabel={isNarrow ? 'Central TX' : 'Central Texas'}
                                style={{ marginTop: '30px' }}
                                disabled={isLoadingOrRefreshing}
                                id='criteria-is_central_texas'
                                checked={internalSearchState.is_central_texas}
                                onChange={(evt) => customUpdateSearchCriteria('is_central_texas', evt.target.checked)}
                            />
                        }
                    </Col>
                </Row>
                <Row>
                    <Col xs={6} sm={4} md={2}>
                        <FormMultiSelect
                            id='criteria-color'
                            label='Colors'
                            value={internalSearchState.color}
                            disabled={isLoadingOrRefreshing}
                            items={pebbleColors}
                            onChange={(v) => customUpdateSearchCriteria('color', v)}
                        />
                    </Col>
                    <Col xs={6} sm={4} md={2}>
                        <FormMultiSelect
                            id='criteria-status'
                            label='Job Status'
                            items={jobStatuses}
                            value={internalSearchState.status}
                            disabled={isLoadingOrRefreshing}
                            onChange={(v) => customUpdateSearchCriteria('status', v)}
                        />
                    </Col>
                    <Col xs={6} sm={4} md={2}>
                        <FormInput
                            label='Address'
                            placeholder='Address'
                            id='criteria-address'
                            value={internalSearchState.address}
                            disabled={isLoadingOrRefreshing}
                            onChange={(evt) => customUpdateSearchCriteria('address', evt.target.value)}
                        />
                    </Col>
                    <Col xs={6} sm={4} md={2}>
                        <FormSuggestWithCreate
                            label='City'
                            placeholder='City'
                            id='criteria-city'
                            value={internalSearchState.city}
                            disabled={isLoadingOrRefreshing}
                            items={cities}
                            onChange={(evt) => customUpdateSearchCriteria('city', (evt && evt.name) || '')}
                        />
                    </Col>
                    <Col xs={6} sm={4} md={2}>
                        <FormMultiSelect
                            id='criteria-job_type'
                            label='Job Type'
                            items={jobTypes}
                            value={internalSearchState.job_type}
                            disabled={isLoadingOrRefreshing}
                            onChange={(v) => customUpdateSearchCriteria('job_type', v)}
                            disableMaxListSize
                        />
                    </Col>
                    <Col xs={6} sm={4} md={2}>
                        <CheckboxInput
                            groupStyles={{ marginTop: '8%' }}
                            disabled={isLoadingOrRefreshing}
                            defaultIndeterminate
                            label='Request Form?'
                            id='criteria-is_request_form'
                            checked={internalSearchState.is_request_form}
                            value={internalSearchState.is_request_form}
                            indeterminate={!internalSearchState.is_request_form && internalSearchState.is_request_form !== false}
                            onChange={(_) => customUpdateSearchCriteria('is_request_form', _)}
                        />
                    </Col>
                </Row>
                {
                    forMap &&
                    <>
                        <Row>
                            <Col xs={6} sm={4} md={2}>
                                <FormInput
                                    label='Scheduled Application Date'
                                    id='criteria-scheduled_app_date'
                                    type='Date'
                                    disabled={isLoadingOrRefreshing}
                                    value={internalSearchState.scheduled_app_date}
                                    onChange={(evt) => customUpdateSearchCriteria('scheduled_app_date', evt.target.value)}
                                />
                            </Col>
                            <Col xs={6} sm={4} md={2}>
                                <FormInput
                                    label={<div><span>Jobs - From Date </span>{dateRangeToolTip(false)}</div>}
                                    id='criteria-entered_start_date'
                                    type='Date'
                                    disabled={isLoadingOrRefreshing}
                                    value={internalSearchState.entered_start_date}
                                    onChange={(evt) => customUpdateSearchCriteria('entered_start_date', evt.target.value)}
                                    groupStyles={isDateRangeSearchWarning() ? { marginTop: -5 } : {}}

                                />

                            </Col>
                            <Col xs={6} sm={4} md={2}>
                                <FormInput
                                    label={<div><span>Jobs - To Date </span>{dateRangeToolTip(true)}</div>}
                                    id='criteria-entered_end_date'
                                    type='Date'
                                    disabled={isLoadingOrRefreshing}
                                    value={internalSearchState.entered_end_date}
                                    onChange={(evt) => customUpdateSearchCriteria('entered_end_date', evt.target.value)}
                                    groupStyles={isEndDateSearchWarning() ? { marginTop: -5 } : {}}
                                />
                            </Col>
                        </Row>
                    </>
                }
            </Col>
            <Col lg={1}>
                <Row>
                    <Col lg={12} sm={6} xs={6}>
                        <Tooltip
                            content={<div>
                                <Icon icon='warning-sign' />
                                <span style={{ fontWeight: 'bold', paddingLeft: 2 }}>Please enter criteria before searching.</span>
                            </div>}
                            position={Position.TOP}
                            disabled={!forMap || isMapSearchCriteriaEntered(getMappedInternalSearchCriteria(forMap, internalSearchState))}
                            intent='warning'>
                            <Button
                                style={{ float: 'right' }}
                                disabled={isLoadingOrRefreshing || (forMap && !isMapSearchCriteriaEntered(getMappedInternalSearchCriteria(forMap, internalSearchState)))}
                                text={isLoadingOrRefreshing ? 'Fetching data...' : forMap ? 'Search' : 'Refresh Results'}
                                onClick={refreshResults}
                                large
                                className='searchButton'
                            />
                        </Tooltip>
                    </Col>
                    <Col lg={12} sm={6} xs={6}>
                        <Button
                            style={{ float: 'right' }}
                            disabled={isLoadingOrRefreshing || (forMap && !isMapSearchCriteriaEntered(getMappedInternalSearchCriteria(forMap, internalSearchState)))}
                            text={isLoadingOrRefreshing ? 'Fetching data...' : 'Clear Filters & Refresh Results'}
                            onClick={clearFiltersAndRefreshResults}
                            large
                            className='searchButton'
                        />
                    </Col>
                </Row>
            </Col>
        </Row>
    </CollapsableCard>
}
